import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-restricted-imports -- We don't use `LocaleSelect` in the main app
import { SimpleSelect } from '@instructure/ui-simple-select';
import t from '../format-message';
export var LocaleSelect = /*#__PURE__*/function (_Component) {
  function LocaleSelect() {
    _classCallCheck(this, LocaleSelect);
    return _callSuper(this, LocaleSelect, arguments);
  }
  _inherits(LocaleSelect, _Component);
  return _createClass(LocaleSelect, [{
    key: "render",
    value: function render() {
      var selectOptionIdPrefix = 'locale-select-option-';
      return /*#__PURE__*/React.createElement(SimpleSelect, {
        interaction: this.props.interaction,
        renderLabel: t('Locale'),
        onChange: this.props.onChange,
        value: this.props.value,
        width: "12rem"
      }, this.props.locales.map(function (locale) {
        return /*#__PURE__*/React.createElement(SimpleSelect.Option, {
          id: selectOptionIdPrefix + locale,
          key: locale,
          value: locale
        }, locale);
      }));
    }
  }]);
}(Component);
_defineProperty(LocaleSelect, "propTypes", {
  onChange: PropTypes.func.isRequired,
  interaction: PropTypes.oneOf(['enabled', 'disabled', 'readonly']),
  value: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.string)
});
_defineProperty(LocaleSelect, "defaultProps", {
  interaction: 'enabled',
  value: null,
  locales: ['en']
});
export default LocaleSelect;